import { useEffect } from 'react'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import { CurrentUser } from '../../../../model/Common/common.interface'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import LessonPreparationCafBody from '../../../new-portal/lessons/LessonPreparationCafBody'
import LessonPreparationTutorBody from '../../../new-portal/lessons/LessonPreparationTutorBody'

// 수업 준비 전 팝업
interface LessonPreparationOverviewModalProps {
  data: any
  currentUser: CurrentUser
}

const LessonOverviewExistUserModal = ({ data, currentUser }: LessonPreparationOverviewModalProps) => {
  const { t } = useTranslation()
  const isWebview = useIsWebview()
  const router = useAppRouter()
  const { sendPageViewEvent } = useEventTracking()
  const isHighlight = data?.highlights?.tags ? data?.highlights?.tags : null
  const isFeedback = data?.feedback?.feedback_tutor_name?.length >= 1

  useEffect(() => {
    if (!router) return
    sendPageViewEvent({ page_name: 'lesson_prep_overview' })
  }, [router.asPath])

  return (
    <div className="flex flex-col">
      {data?.feedback.same_tutor_count >= 1 && (
        <div className="flex space-x-[8px] rounded-[5px] bg-purple-50 py-[4px] pl-[8px]">
          <span className="text-[14px] font-bold text-purple-500">
            {t(n_lesson_prep.overview.info_class_count(data?.feedback.same_tutor_count))}
          </span>
          <span className="text-[14px] font-medium text-gray-700">
            {t(n_lesson_prep.overview.info_class_desc(data?.feedback?.feedback_tutor_name))}
          </span>
        </div>
      )}
      <div className="mt-[36px] space-y-24">
        {!isHighlight &&
          !isFeedback && ( // 둘 다 없는 경우
            <div className="flex-start flex bg-gray-50 py-12 px-16">
              <span className="text-[12px] font-normal text-gray-600">{t(n_lesson_prep.overview.desc)}</span>
            </div>
          )}
        {!isHighlight && isFeedback ? ( // 튜터 피드백만 있는 경우
          <LessonPreparationTutorBody currentUser={currentUser} data={data?.feedback && data?.feedback} />
        ) : (
          <>{isWebview && <div className="h-full"></div>}</>
        )}
        {isHighlight && !isFeedback ? ( // caf 정보만 있는 경우
          <LessonPreparationCafBody currentUser={currentUser} data={data?.highlights && data?.highlights} />
        ) : (
          <>{isWebview && <div className="h-full"></div>}</>
        )}
        {isHighlight && isFeedback ? (
          <>
            <LessonPreparationCafBody currentUser={currentUser} data={data?.highlights && data?.highlights} />
            <LessonPreparationTutorBody currentUser={currentUser} data={data?.feedback && data?.feedback} />
          </>
        ) : (
          <>{isWebview && <div className="h-full"></div>}</>
        )}
      </div>
    </div>
  )
}

export default LessonOverviewExistUserModal
